import { Alert, Box, Typography } from '@mui/material'
import { useState } from 'react'
import { SubmitP2PReport } from '../../../../services/peerToPeer/PeerToPeerService'
import { Modal } from '../../../customComponents/Modal'

interface Props {
  open: boolean
  reportingYearId: number
  onClose: () => void
  onSubmitted: () => void
}

export const SubmitReportModal = ({ open, reportingYearId, onClose, onSubmitted }: Props): JSX.Element => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const submit = async (): Promise<void> => {
    setIsSubmitting(true)
    setError(null)
    const result = await SubmitP2PReport({ reportingYearId })
    setIsSubmitting(false)
    if (!result.success) {
      setError(result.errors[0] ?? 'Unable to submit your report. Please try again.')
      return
    }
    onSubmitted()
  }

  return (
    <Modal
      open={open}
      title='Ready to Submit?'
      maxWidth='sm'
      width='544px'
      bodyContent={
        <>
          <Typography variant='h5'>You&apos;re all set! Once submitted, your report will be sent to the START team.</Typography>
          {error != null && <Box sx={{ mt: '12px' }}><Alert severity='error' data-testid='p2pSubmitReportError'>{error}</Alert></Box>}
        </>
      }
      cancelButtonText='Not Yet'
      confirmButtonText='Submit'
      cancelButtonTestId='p2pSubmitReportNotYet'
      confirmButtonTestId='p2pSubmitReportConfirm'
      isUpdateDisabled={isSubmitting}
      isCancelDisabled={isSubmitting}
      onClose={onClose}
      onConfirm={() => { void submit() }}
      data-testid='p2pSubmitReportModal'
    />
  )
}
